// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GuestImportModal_importModalInner__PliNs {
  max-width: 760px !important;
  width: 95%;
}

.GuestImportModal_pasteArea__AvvNa {
  width: 100%;
  min-height: 180px;
  max-height: 280px;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #dfe4eb;
  font-family: "Inter", monospace;
  font-size: 13px;
  font-weight: 400;
  color: #313131;
  resize: vertical;
  box-sizing: border-box;
  line-height: 1.45;
  background: #fff;
}
.GuestImportModal_pasteArea__AvvNa:focus {
  outline: none;
  border-color: #7ca6bd;
}
.GuestImportModal_pasteArea__AvvNa::placeholder {
  color: #9aa4b3;
  font-family: "Inter", sans-serif;
}

.GuestImportModal_columnHelp__pw0FF {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.GuestImportModal_summaryRow__ftk\\+q {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}

.GuestImportModal_previewTableWrap__nnEdG {
  max-height: 360px;
  overflow: auto;
  border: 1px solid #dfe4eb;
  border-radius: 8px;
}

.GuestImportModal_previewTable__-jO1- {
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 13px;
}
.GuestImportModal_previewTable__-jO1- th,
.GuestImportModal_previewTable__-jO1- td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eef1f5;
  vertical-align: top;
}
.GuestImportModal_previewTable__-jO1- th {
  position: sticky;
  top: 0;
  background: #f2f6f8;
  font-weight: 600;
  color: #313131;
  z-index: 1;
}
.GuestImportModal_previewTable__-jO1- tr:last-child td {
  border-bottom: none;
}
.GuestImportModal_previewTable__-jO1- .GuestImportModal_muted__2rXng {
  color: #8692a4;
}
.GuestImportModal_previewTable__-jO1- .GuestImportModal_errorText__ueZOZ {
  color: #d92d20;
  font-size: 12px;
  margin-top: 4px;
}
.GuestImportModal_previewTable__-jO1- .GuestImportModal_dupText__khF3o {
  color: #ff9b21;
  font-size: 12px;
  margin-top: 4px;
}

.GuestImportModal_exampleBlock__NepnC {
  margin-top: 12px;
  padding: 10px 12px;
  background: #f2f6f8;
  border-radius: 8px;
  font-family: "Inter", monospace;
  font-size: 12px;
  color: #313131;
  white-space: pre-wrap;
  line-height: 1.5;
}`, "",{"version":3,"sources":["webpack://./src/components/guestList/GuestImportModal.module.scss"],"names":[],"mappings":"AAAA;EACC,2BAAA;EACA,UAAA;AACD;;AAEA;EACC,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AACD;AACC;EACC,aAAA;EACA,qBAAA;AACF;AAEC;EACC,cAAA;EACA,gCAAA;AAAF;;AAIA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AADD;;AAIA;EACC,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;AADD;;AAIA;EACC,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AADD;;AAIA;EACC,WAAA;EACA,yBAAA;EACA,gCAAA;EACA,eAAA;AADD;AAGC;;EAEC,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AADF;AAIC;EACC,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AAFF;AAKC;EACC,mBAAA;AAHF;AAMC;EACC,cAAA;AAJF;AAOC;EACC,cAAA;EACA,eAAA;EACA,eAAA;AALF;AAQC;EACC,cAAA;EACA,eAAA;EACA,eAAA;AANF;;AAUA;EACC,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;AAPD","sourcesContent":[".importModalInner {\r\n\tmax-width: 760px !important;\r\n\twidth: 95%;\r\n}\r\n\r\n.pasteArea {\r\n\twidth: 100%;\r\n\tmin-height: 180px;\r\n\tmax-height: 280px;\r\n\tpadding: 12px;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid #dfe4eb;\r\n\tfont-family: 'Inter', monospace;\r\n\tfont-size: 13px;\r\n\tfont-weight: 400;\r\n\tcolor: #313131;\r\n\tresize: vertical;\r\n\tbox-sizing: border-box;\r\n\tline-height: 1.45;\r\n\tbackground: #fff;\r\n\r\n\t&:focus {\r\n\t\toutline: none;\r\n\t\tborder-color: #7ca6bd;\r\n\t}\r\n\r\n\t&::placeholder {\r\n\t\tcolor: #9aa4b3;\r\n\t\tfont-family: 'Inter', sans-serif;\r\n\t}\r\n}\r\n\r\n.columnHelp {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px;\r\n\tmargin-top: 8px;\r\n}\r\n\r\n.summaryRow {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 8px;\r\n\talign-items: center;\r\n\tmargin-bottom: 12px;\r\n}\r\n\r\n.previewTableWrap {\r\n\tmax-height: 360px;\r\n\toverflow: auto;\r\n\tborder: 1px solid #dfe4eb;\r\n\tborder-radius: 8px;\r\n}\r\n\r\n.previewTable {\r\n\twidth: 100%;\r\n\tborder-collapse: collapse;\r\n\tfont-family: 'Inter', sans-serif;\r\n\tfont-size: 13px;\r\n\r\n\tth,\r\n\ttd {\r\n\t\tpadding: 10px 12px;\r\n\t\ttext-align: left;\r\n\t\tborder-bottom: 1px solid #eef1f5;\r\n\t\tvertical-align: top;\r\n\t}\r\n\r\n\tth {\r\n\t\tposition: sticky;\r\n\t\ttop: 0;\r\n\t\tbackground: #f2f6f8;\r\n\t\tfont-weight: 600;\r\n\t\tcolor: #313131;\r\n\t\tz-index: 1;\r\n\t}\r\n\r\n\ttr:last-child td {\r\n\t\tborder-bottom: none;\r\n\t}\r\n\r\n\t.muted {\r\n\t\tcolor: #8692a4;\r\n\t}\r\n\r\n\t.errorText {\r\n\t\tcolor: #d92d20;\r\n\t\tfont-size: 12px;\r\n\t\tmargin-top: 4px;\r\n\t}\r\n\r\n\t.dupText {\r\n\t\tcolor: #ff9b21;\r\n\t\tfont-size: 12px;\r\n\t\tmargin-top: 4px;\r\n\t}\r\n}\r\n\r\n.exampleBlock {\r\n\tmargin-top: 12px;\r\n\tpadding: 10px 12px;\r\n\tbackground: #f2f6f8;\r\n\tborder-radius: 8px;\r\n\tfont-family: 'Inter', monospace;\r\n\tfont-size: 12px;\r\n\tcolor: #313131;\r\n\twhite-space: pre-wrap;\r\n\tline-height: 1.5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"importModalInner": `GuestImportModal_importModalInner__PliNs`,
	"pasteArea": `GuestImportModal_pasteArea__AvvNa`,
	"columnHelp": `GuestImportModal_columnHelp__pw0FF`,
	"summaryRow": `GuestImportModal_summaryRow__ftk+q`,
	"previewTableWrap": `GuestImportModal_previewTableWrap__nnEdG`,
	"previewTable": `GuestImportModal_previewTable__-jO1-`,
	"muted": `GuestImportModal_muted__2rXng`,
	"errorText": `GuestImportModal_errorText__ueZOZ`,
	"dupText": `GuestImportModal_dupText__khF3o`,
	"exampleBlock": `GuestImportModal_exampleBlock__NepnC`
};
export default ___CSS_LOADER_EXPORT___;
